/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

( function( $ ) {

    $( document ).ready( function() {
        
        if ( typeof $.fn.lightSlider !== 'undefined' ) {

            // On va chercher les listes
            const slideshow_lists = document.getElementsByClassName( 'hemis-blocks-slideshow' );
            
            // Pour chaque liste
            for ( let i = 0; i < slideshow_lists.length; i++ ) {

                // Si la liste est déjà un slideshow, on passe à la suivante
                if ( slideshow_lists[i].classList.contains( 'lSSlide' ) ) {
                    continue;
                }

                // On récupère les paramètres de la liste
                const autoplay = slideshow_lists[i].getAttribute( 'data-autoplay' ) === 'true';
                const arrows = slideshow_lists[i].getAttribute( 'data-arrows' ) === 'true';
                const dots = slideshow_lists[i].getAttribute( 'data-dots' ) === 'true';
                const showThumbnails = slideshow_lists[i].getAttribute( 'data-showthumbnails' ) === 'true';
                const loop = slideshow_lists[i].getAttribute( 'data-loop' ) === 'true';
                const pause = parseInt( slideshow_lists[i].getAttribute( 'data-pause' ) );
                const speed = parseInt( slideshow_lists[i].getAttribute( 'data-speed' ) );
                const transition = slideshow_lists[i].getAttribute( 'data-transition' );
                const gallery = slideshow_lists[i].getAttribute( 'data-gallery' ) === 'true';

                const calculateThumbnailsContainerLeft = function( slideshow ) {
                    if ( showThumbnails ) {
                        let thumbnails_container = slideshow.get(0).closest( '.slideshow-container').querySelector( '.hemis-blocks-slideshow-gallery' );
                        if ( thumbnails_container ) {
                            if ( thumbnails_container.offsetWidth < thumbnails_container.parentElement.offsetWidth ) {
                                const left = thumbnails_container.parentElement.offsetWidth / 2 - thumbnails_container.offsetWidth / 2;
                                thumbnails_container.style.left = left + 'px';
                            } else {
                                for ( let j = 0; j < thumbnails_container.childElementCount; j++ ) {
                                    let left = ( thumbnails_container.children[j].offsetLeft - ( thumbnails_container.parentElement.offsetWidth / 2 ) + ( thumbnails_container.children[j].offsetWidth / 2 ) ) * -1;
                                    if ( left > 0 ) {
                                        left = 0;
                                    }
                                    if ( left < thumbnails_container.parentElement.offsetWidth - thumbnails_container.offsetWidth ) {
                                        left = thumbnails_container.parentElement.offsetWidth - thumbnails_container.offsetWidth;
                                    }
                                    thumbnails_container.style.left = left + 'px';
                                }
                            }
                        }
                    }
                }

                // On initialise le slider
                const slideshow = $( slideshow_lists[i] ).lightSlider( {
                    item: 1,
                    slideMargin: 0,
                    auto: autoplay,
                    controls: false,
                    pager: dots,
                    gallery: showThumbnails,
                    loop: loop,
                    pause: pause,
                    speed: speed,
                    mode: transition,
                    onSliderLoad: function( el ) {

                        if ( 'undefined' !== typeof lightGallery && gallery ) {
                            lightGallery( slideshow_lists[i], {
                                // selector: '.hemis-blocks-slide:not(.clone) .hemis-blocks-image',
                                selector: '.hemis-blocks-slide:not(.clone)',
                                thumbnail: showThumbnails,
                                download: false,
                                actualSize: false,
                                autoplay: autoplay,
                                pause: pause,
                                speed: speed,
                                plugins: [lgVideo]
                            } );
                        }

                        if ( arrows ) {
                            let prev_button = slideshow.get(0).closest( '.slideshow-container').querySelector( '.custom-prev-next.prev' );
                            let next_button = slideshow.get(0).closest( '.slideshow-container').querySelector( '.custom-prev-next.next' );
                            if ( prev_button && next_button ) {
                                prev_button.addEventListener( 'click', function() {
                                    el.goToPrevSlide();
                                } );
                                next_button.addEventListener( 'click', function() {
                                    el.goToNextSlide();
                                } );
                            }
                        }

                        if ( showThumbnails ) {
                            let thumbnails_container = slideshow.get(0).closest( '.slideshow-container').querySelector( '.hemis-blocks-slideshow-gallery' );
                            if ( thumbnails_container ) {
                                for ( let j = 0; j < thumbnails_container.childElementCount; j++ ) {
                                    thumbnails_container.children[j].addEventListener( 'click', function() {
                                        el.goToSlide( j );
                                    } );
                                }
                            }
                        }

                        calculateThumbnailsContainerLeft( el );
                    },
                    onBeforeSlide: function( el ) {
                        calculateThumbnailsContainerLeft( el );
                    }
                } );

                window.addEventListener( 'resize', function() {
                    calculateThumbnailsContainerLeft( slideshow );
                });

            }

        }

    } );

} )(jQuery);